/**
 * Verifica si el JWT almacenado en localStorage expiró.
 * Decodifica el payload del token (sin verificar firma) y compara
 * el claim `exp` con la fecha actual.
 *
 * @returns {boolean} true si el token expiró o no existe, false si es válido
 */
export function tokenExpirado() {
  const raw = localStorage.getItem("accessToken");
  if (!raw) return true;

  const token = raw.replace(/^"+|"+$/g, "").trim();
  if (!token) return true;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;

    const payload = JSON.parse(atob(parts[1]));
    if (typeof payload.exp !== "number") return false;

    return payload.exp * 1000 < Date.now();
  } catch {
    return false;
  }
}

export function redirectLoginExpirado() {
  window.location.href = '/login?expirada=1';
}
